import makeStyles from '@mui/styles/makeStyles'

const bp = 'sm'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '35px',
    marginBottom: '1.5rem',

    [theme.breakpoints.down(bp)]: {
      marginBottom: '2rem'
    }
  },

  label: {
    minWidth: '125px',
    width: '125px',
    display: 'inline-flex',
    textTransform: 'uppercase',
    cursor: 'default',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontSize: theme.size.sm,
    color: theme.palette.textLight,

    [theme.breakpoints.down(bp)]: {
      minWidth: '155px',
      width: '155px'
    }
  },

  icon: {
    marginRight: '5px'
  },

  input: {
    flexGrow: 'unset',
    outline: 'none',
    border: 'none',
    marginLeft: '2rem',
    fontSize: theme.size.sm,
    opacity: '0.7',
    padding: 0,
    width: 'unset',
    background: 'transparent',
    cursor: 'pointer',

    [theme.breakpoints.down(bp)]: {
      margin: '0',
      fontSize: theme.size.sm,
      color: theme.palette.textLight
    }
  }
}))

export default useStyles
